export default function fixTimeInput(raw) {
	const onlyDigits = raw.replace(/[^0-9]/g, '').slice(0, 4);

	if (onlyDigits.length <= 2) {
		return onlyDigits;
	}

	const hh = onlyDigits.slice(0, 2);
	const mm = onlyDigits.slice(2, 4);

	let hour = parseInt(hh, 10);
	let minute = parseInt(mm, 10);

	// ✅ одразу повертаємо результат — і більше нічого не робимо
	if (hour === 24 && minute === 0) {
		return '00:00';
	}

	// Тепер можна обмежувати
	if (hour > 23) hour = 23;
	if (minute > 59) minute = 59;

	return `${ hour.toString().padStart(2, '0') }:${ minute.toString().padStart(2, '0') }`;
}
